// src/components/LanguageSelector.jsx
import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useTranslation } from 'react-i18next';
import Flag from 'react-world-flags'; // Import the react-world-flags component
import API_URLS from '../apiConfig';

const LanguageSelector = () => {
  const [langData, setLangData] = useState([]);
  const [defaultlang, setDefaultLang] = useState(localStorage.getItem('lang')?localStorage.getItem('lang'):'en');
  const [defaultflag, setDefaultflag] = useState(localStorage.getItem('flag')?localStorage.getItem('flag'):'US');
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(defaultlang);
  const [selectedFlag, setSelectedFlag] = useState(defaultflag);

  useEffect(() => {
    axios
      .get(API_URLS.getLang)
      .then((response) => {
        if (response.data) {
          setLangData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });
  }, []);

  // Save to localStorage whenever the name changes
  useEffect(() => {
    if (defaultlang) {
      localStorage.setItem('lang', defaultlang);
    }
    if (defaultflag) {
      localStorage.setItem('flag', defaultflag);
    }
  }, [defaultlang,defaultflag]);

  const handleToggleDropdown = (event) => {
    // Prevent the dropdown from closing when clicking inside the dropdown itself
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleSelectLanguage = (languageCode,flagCode) => {
    setSelectedLanguage(languageCode);
    setSelectedFlag(flagCode);
    i18n.changeLanguage(languageCode);
    setDefaultLang(languageCode);
    setDefaultflag(flagCode);
    setIsOpen(false); // Close the dropdown after selection
    // Reload the current page
    window.location.reload();
  };

  // Close dropdown if clicking outside the dropdown
  const handleClickOutside = (event) => {
    if (!event.target.closest('.language-selector')) {
      setIsOpen(false);
    }
  };

  // Attach event listener for clicking outside to close the dropdown
  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener when the component is unmounted
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-selector">
      <div className="dropdown" onClick={handleToggleDropdown}>
        <button className="dropdown-button">
          <Flag
            code={selectedFlag}
            style={{ width: 24, height: 24, marginRight: 10 }}
            alt={selectedLanguage+' flag'}
          />
          {selectedLanguage==='br'?'PT':selectedLanguage}
        </button>
        {isOpen && (
          <div className="dropdown-menu">
            {langData.map((datalang, index) => (
              <div key={index} className="dropdown-item" onClick={() => handleSelectLanguage(datalang.meta_key.slice(-2),datalang.flag)}>
                <Flag code={datalang.flag} style={{ width: 24, height: 24, marginRight: 10 }} alt={datalang.name+' Flag'} />
                {datalang.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
